import * as React from 'react'
import { Button } from '../../components/ui/button'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { MessageSquarePlus , X , Star } from 'lucide-react'
import { AnimatePresence, motion } from "framer-motion"

type QuickMessagesMenuProps = { 
  questions: string[]
  favorites: string[]
  context: string
  disabled: boolean
  handleCreatePrompt: (prompt: string, context: string) => void
  handleQuickMessages: (prompt: string) => void
};

export default function QuickMessagesMenu({questions, favorites, context, disabled, handleCreatePrompt, handleQuickMessages}: QuickMessagesMenuProps) {
  const [isOpen, setIsOpen] = React.useState(false)

  const handleOnSelect = (prompt: string) => {
      handleCreatePrompt(prompt, context)
      handleQuickMessages(prompt)
  }

  return(
    <div>
      <DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
        <DropdownMenu.Trigger>
        {isOpen ? 
          <Button
            className=""
            title="Add custom prompt to provide more context to the conversation"
            variant="secondary"
            size="sm"
            onClick={() => setIsOpen(!isOpen)}
            disabled={disabled}
          >
            <X className="cursor-pointer" size={20}/>
          </Button>
          : <Button
              className=""
              title="Add custom prompt to provide more context to the conversation"
              variant="ghost"
              size="sm"
              onClick={() => setIsOpen(!isOpen)}
              disabled={disabled}
            >
              <MessageSquarePlus size={20}/>
            </Button>
        }
      </DropdownMenu.Trigger>
        <AnimatePresence>
          {isOpen && (
            <DropdownMenu.Portal forceMount>
              <DropdownMenu.Content side="top" align="end" className="flex flex-col items-end mb-3 overflow-y-auto max-h-80">
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                  {favorites && favorites.map((favorite, index) => (
                  <DropdownMenu.Item key={index} onSelect={() => handleOnSelect(favorite)}>
                      <Button
                        className="hover:bg-slate-600 w-52 sm:w-96 h-auto my-0.5"
                        style={{ minHeight: '3rem' }}
                        disabled={disabled}
                      >
                        <div className="w-full flex gap-1">
                            <div className="w-11/12 text-center flex justify-center items-center">{favorite}</div>
                            <div className="w-1/12 flex justify-end items-center">
                                <Star stroke="black" fill="yellow" size={16}/>
                            </div>
                        </div>
                      </Button>
                    </DropdownMenu.Item>
                  ))}
                  {/* <DropdownMenu.Separator style={{ borderBottom: '3px solid #475569' }}/> */}
                  {questions && questions.map((question, index) => (
                    <DropdownMenu.Item key={index} onSelect={() => handleOnSelect(question)}>
                      <Button
                        className="hover:bg-slate-600 w-52 sm:w-96 h-auto my-0.5"
                        style={{ minHeight: '3rem' }}
                        disabled={disabled}
                      >
                        {question}
                      </Button>
                    </DropdownMenu.Item>
                  ))}
                </motion.div>
              </DropdownMenu.Content>
            </DropdownMenu.Portal>
          )}
        </AnimatePresence>
      </DropdownMenu.Root>
    </div>
  )
}